import { memo, useEffect, useState } from "react";
import { FaCheckCircle, FaExternalLinkAlt, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PulseLoader, ScaleLoader } from "react-spinners";
import toast from "react-hot-toast";
import { SelectAdmin } from "../../../store/slice/admin";
import { AppDispatch } from "../../../store";
import {
  Approve_Decline_Deposit,
  getDeposits,
} from "../../../store/service/adminApi";
import DashboardLayout from "../../../Layout/DashBoardLayout";
import ModalP from "../../../components/ModalP";
import { Fmtd_Date } from "../../../Utils/functions";
import Pagination from "../../../components/Pagination";

export default function AllDeposits() {
  const dispatch = useDispatch<AppDispatch>();
  const { deposit, loading, pagination } = useSelector(SelectAdmin);
  const [isLoading, setIsLoading] = useState(false);
  const FetchData = async (params: { page: number } | null) => {
    try {
      await dispatch(getDeposits(params));
    } catch (error) {
      console.log(error);
    }
  };

  const handleAction = async (params: Action) => {
    try {
      setIsLoading(true);
      const req = await Approve_Decline_Deposit(params);
      toast.success(req.message);
      await FetchData(null);
      setIsLoading(false);
    } catch (error) {
      toast.error("Approval Failed");
      setIsLoading(false);
    }
  };

  const sendRequest = (val: number) => {
    return FetchData({ page: val });
  };

  useEffect(() => {
    FetchData(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DashboardLayout>
      <div className=" relative  min-w-0 break-words w-full  ">
        <ModalP
          hasCancelButton={false}
          modalOpen={isLoading}
          handleClose={() => {}}
        >
          <div className=" px-10 py-4 ">
            <PulseLoader />
          </div>
        </ModalP>
        <p className=" text-[20px] md:text-[25px] font-[700] ">Deposits</p>
        <div className="dash_webkit block pt-10 w-full overflow-x-auto ">
          <table className=" bg-red-00 w-full md:w-full ">
            <thead className=" mb-7 ">
              <tr className=" text-left  border-b-2  border-[#d7d7d7] ">
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Depositor
                </th>
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Amount
                </th>
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Plan
                </th>
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Image
                </th>
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Status
                </th>
                <th className=" pb-7 px-3 tracking-wide whitespace-nowrap  ">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#d7d7d7]">
              {!loading &&
                deposit.length !== 0 &&
                deposit?.map((deposit) => (
                  <TableRow
                    key={deposit?.id}
                    fullname={deposit?.fullname!}
                    amount={Number(deposit?.amount!)}
                    id={deposit?.id}
                    plan={deposit?.plan}
                    image={deposit?.image}
                    status={deposit?.status}
                    date={Fmtd_Date(deposit?.created_at)}
                    onClick={(params: Action) => handleAction(params)}
                  />
                ))}

              {!loading && deposit.length === 0 && (
                <tr>
                  <td className="py-0 text-center " colSpan={6}>
                    <div className="w-full py-10 font-bold bg-main text-white text-sm md:text-[20px] flex justify-center items-center ">
                      You Don't Have Any Record
                    </div>
                  </td>
                </tr>
              )}

              {loading && (
                <tr>
                  <td className="py-6 text-center " colSpan={6}>
                    <div className="w-full py-1 bg-red-00 flex justify-center items-center ">
                      <ScaleLoader />
                    </div>
                  </td>
                </tr>
              )}

              <tr>
                <td className="pt-6" colSpan={6}>
                  <Pagination
                    currentPage={pagination?.current}
                    totalPages={pagination?.total}
                    sendRequest={sendRequest}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}

const TableRow = memo(
  ({
    fullname,
    amount,
    plan,
    date,
    image,
    status,
    onClick,
    id,
  }: {
    id: string;
    fullname: string;
    amount: number;
    plan: string;
    date: string;
    image: string;
    status: string;
    onClick: (params: Action) => void;
  }) => {
    return (
      <tr className={`text-left border-b-2  border-[#d7d7d7]`}>
        <td className="py-5 whitespace-nowrap px-3">{fullname}</td>
        <td className="py-5 whitespace-nowrap px-3">${amount}</td>
        <td className="py-5 whitespace-nowrap px-3">{plan}</td>
        <td className="py-5 whitespace-nowrap px-3">
          {image ? (
            <Link to={image} target="_blank">
              <div className="flex text-blue-600  items-center gap-2 ">
                View Image <FaExternalLinkAlt />
              </div>
            </Link>
          ) : (
            <>No Image</>
          )}
        </td>
        <td className="py-5 whitespace-nowrap px-3">{status}</td>
        <td className="py-5 whitespace-nowrap px-3">{date}</td>
        <td className="py-5 whitespace-nowrap px-3">
          <div className="flex gap-3 items-center ">
            <button
              className="bg-slate-200 border-2 border-green-500 p-3 rounded-full  "
              title="Approve Deposit"
              onClick={() => onClick({ id, action: "APPROVE" })}
            >
              <FaCheckCircle fill="green" />
            </button>
            <button
              className="bg-slate-200 border-2 border-red-500 p-3 rounded-full"
              title="Reject Deposit"
              onClick={() => onClick({ id, action: "DECLINE" })}
            >
              <FaTimes fill="red" />
            </button>
          </div>
        </td>
      </tr>
    );
  }
);
